import { render, staticRenderFns } from "./VNotificationListItem.vue?vue&type=template&id=f08bf9be"
import script from "./VNotificationListItem.vue?vue&type=script&lang=js"
export * from "./VNotificationListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports